<!-- <object  [data]="dataUrl$ | async" type="application/pdf"></object> -->

<iframe *ngIf="IsPdf" [src]="dataUrl$ | async">
    This browser does not support PDFs. Please download the PDF to view it:
    <a [href]="dataUrl$ | async">Download PDF</a></iframe>

<img *ngIf="IsImage" [src]="dataUrl$ | async" />
